// FT-183: гейт страницы раздела, скрытого для типа техники компании.
//
// Гейт роутера (router/rentalObjectGate.js) закрывает прямую ссылку, но пропускает,
// пока компании нет в сторе. Этот гейт закрывает остальное: компания загрузилась
// после перехода или сотрудник сменил филиал на вело-филиал, стоя на странице
// раздела (AppHeader коммитит setCompany ответом API). Immediate-вотчер срабатывает
// и при открытии, и при каждой смене компании.
//
// Подключение — обычным объектом-миксином плюс опция страницы с её фичей:
//   mixins: [rentalObjectSectionGuard], rentalObjectSection: "fines",
// Фабрика `guard("fines")` не годится: статическая проверка вызовов методов
// (tests/unit/danglingComponentMethods.spec.js) резолвит только импортированные
// из src/ миксины-объекты.
import { rentalObjectHas, companyRentalObject } from "@/utils/rentalObjectFeatures";

export default {
  computed: {
    rentalObjectSectionHidden() {
      const rentalObject = companyRentalObject(this.$store && this.$store.getters.getCompany);
      return !rentalObjectHas(rentalObject, this.$options.rentalObjectSection);
    },
  },
  watch: {
    rentalObjectSectionHidden: {
      immediate: true,
      handler(hidden) {
        if (hidden) this.$router.replace({ name: "Home" }).catch(() => {});
      },
    },
  },
};
